import $ from 'jquery';
import { MQ } from '../tools/MQ.js';

export const init = () => {
	const $container = $('.cng-calculator__container');
	if (!$container.length) {
		return;
	}

	///////////////////////////////////////////////////////
	/// CONTSTANTS AND VARIABLES
	///////////////////////////////////////////////////////

	const WindowSize = {
		UNINITIALIZED: 0,
		SMALL: 1,
		LARGE: 2,
	};

	const transitionDurationMs = 500,
		cngPrice = $container.data('cng-price'),
		consumptionRatioPetrol = $container.data('consumption-ratio-petrol'),
		consumptionRatioDiesel = $container.data('consumption-ratio-diesel'),
		$fuelPriceColumn = $container.find('.fuel-price-col'),
		$consumptionColumn = $container.find('.consumption-col');

	let lastWindowSize = WindowSize.UNINITIALIZED;

	let fuelPriceParams = {
		inputId: 'fuelPriceInput',
		labelId: 'fuelPriceLabel',
		labelText: $container.data('fuel-price-label-text'),
		suffix: $container.data('price-per-liter-suffix'),
		min: $container.data('fuel-price-min'),
		max: $container.data('fuel-price-max'),
		value: parseFloat($container.data('fuel-price-value')),
		step: $container.data('fuel-price-step'),
		decimalPlaces: $container.data('fuel-price-decimal-places'),
	};

	let consumptionParams = {
		inputId: 'consumptionInput',
		labelId: 'consumptionLabel',
		labelText: $container.data('consumption-label-text'),
		suffix: $container.data('consumption-per-hundred-km-suffix'),
		min: $container.data('consumption-min'),
		max: $container.data('consumption-max'),
		value: parseFloat($container.data('consumption-value')),
		step: $container.data('consumption-step'),
		decimalPlaces: $container.data('consumption-decimal-places'),
	};

	const $form = $container.find('.cng-calculator__form'),
		$result = $container.find('.cng-calculator__result'),
		$switchInput = $container.find('.inp-switch__wrapper'),
		$mileageInputSlider = $form.find('#mileageInput .slider__input'),
		$mileageInputDisplay = $form.find('#mileageInput .slider__input__display'),
		$submitBtn = $form.find('.cng-calculator__link .btn');

	const numSubstitutionRegex = /\s*(\d+(?:[\,\.\s]\d+)*)\s(.*)/;

	///////////////////////////////////////////////////////
	/// CALLBACKS
	///////////////////////////////////////////////////////

	$(window).on('resize', function () {
		const windowSize = getWindowSize();
		if (windowSize !== lastWindowSize) {
			if (lastWindowSize !== WindowSize.UNINITIALIZED) {
				// update price values
				const params = getCalculationParams();
				fuelPriceParams.value = params.fuelPrice;
				consumptionParams.value = params.consumption;
			}

			if (windowSize === WindowSize.SMALL) {
				setSmallInput($fuelPriceColumn, fuelPriceParams);
				setSmallInput($consumptionColumn, consumptionParams);
				attachTextInputCallbacks();
			} else {
				setLargeInput($fuelPriceColumn, fuelPriceParams);
				setLargeInput($consumptionColumn, consumptionParams);
				attachArrowCallbacks();
			}
		}

		lastWindowSize = windowSize;
	});

	$submitBtn.on('click', function (event) {
		event.preventDefault();

		const params = getCalculationParams();
		const result = calculate(params);
		fillResult(result);

		$form.animate({ opacity: 0 }, transitionDurationMs, function () {
			$form.hide();
			$result.show();
			$result.animate({ opacity: 1 }, transitionDurationMs);
		});
	});

	/** On slider change callback */
	$mileageInputSlider.on('input change', function () {
		$mileageInputSlider.css('--val', this.value);
		setSliderDisplayNumber(this.value);
	});

	function attachTextInputCallbacks() {
		$container.find('input[type="number"]').on('change', function () {
			const decimalPlaces = parseInt($(this).data('decimal-places')),
				suffix = $(this).data('suffix'),
				minValue = parseFloat($(this).attr('min')),
				maxValue = parseFloat($(this).attr('max'));

			let value = parseFloat($(this).val());

			// clamp value between [min, max]
			value = Math.min(Math.max(value, minValue), maxValue);

			const valueText = value.toFixed(decimalPlaces);

			$(this).val(valueText);
			$(this).attr('value', value);
			$(this).attr('aria-valuenow', value);
			$(this).attr('aria-valuetext', `${valueText} ${suffix}`);
		});
	}

	function attachArrowCallbacks() {
		/** On arrow up click callback */
		$container.find('.arrow-up').on('click', function (event) {
			event.preventDefault();

			updateInputDisplay($(this).parent().parent(), 1);
		});

		/** On arrow down click callback */
		$container.find('.arrow-down').on('click', function (event) {
			event.preventDefault();

			updateInputDisplay($(this).parent().parent(), -1);
		});

		/** On keyboard arrow key input */
		$('#fuelPriceInput,#consumptionInput').on('keydown', function (event) {
			if (event.isDefaultPrevented()) return;

			switch (event.key) {
				case 'Up':
				case 'ArrowUp':
					updateInputDisplay($(this), 1);
					break;
				case 'Down':
				case 'ArrowDown':
					updateInputDisplay($(this), -1);
					break;
				default:
					return;
			}

			event.preventDefault();
		});
	}

	///////////////////////////////////////////////////////
	/// HELPERS
	///////////////////////////////////////////////////////

	function getCalculationParams() {
		return {
			fuelPrice: parseFloat($('#fuelPriceInput').attr('value')),
			consumption: parseFloat($('#consumptionInput').attr('value')),
			mileage: parseInt($('#mileageInput .slider__input').first().val()),
			isDiesel: $switchInput.hasClass('inp-switch__wrapper--on'),
		};
	}

	function calculate(params) {
		const cngConsumption = params.consumption / (params.isDiesel ? consumptionRatioDiesel : consumptionRatioPetrol),
			cngTotal = (cngConsumption * cngPrice * params.mileage) / 100,
			stdTotal = (params.consumption * params.fuelPrice * params.mileage) / 100;

		return {
			annualSavings: stdTotal - cngTotal,
			annualSavingsPercent: ((stdTotal - cngTotal) / stdTotal) * 100,
		};
	}

	function fillResult(result) {
		// annual savings
		let savingsText = $result.find('ul li:first').html();
		savingsText = savingsText.replace('$', Math.round(result.annualSavings).toLocaleString('cs-CZ', { style: 'decimal' }));
		savingsText = savingsText.replace('#', Math.round(result.annualSavingsPercent));
		$result.find('ul li:first').html(savingsText);
	}

	function updateInputDisplay($input, multiplier) {
		const $textSpan = $input.find('.inp__display'),
			decimalPlaces = parseInt($input.data('decimal-places')),
			step = parseFloat($input.data('step')),
			min = parseFloat($input.data('min')),
			max = parseFloat($input.data('max'));

		const text = $textSpan.text();
		const suffix = text.replace(numSubstitutionRegex, '$2');

		let number = parseFloatFromInput(text);
		number += multiplier * step;

		if (number < min || number > max) return false;

		$input.attr('value', number);
		$input.attr('aria-valuenow', number);
		$input.attr('aria-valuetext', `${number.toFixed(decimalPlaces)} ${suffix}`);
		$textSpan.html(`${number.toFixed(decimalPlaces)}&nbsp;${suffix}`);
	}

	function setSliderDisplayNumber(numberStr) {
		const sliderValue = parseInt(numberStr);

		const displayText = $mileageInputDisplay
			.text()
			.replace(numSubstitutionRegex, `${sliderValue.toLocaleString('cs-CZ', { style: 'decimal' })} $2`);

		$mileageInputDisplay.html(displayText);
	}

	function parseFloatFromInput(input) {
		const n = parseFloat(input.replace(numSubstitutionRegex, '$1'));

		if (isNaN(n)) throw 'Could not parse float from ' + input;

		return n;
	}

	function initSlider() {
		const min = $mileageInputSlider.attr('min');
		const max = $mileageInputSlider.attr('max');
		const val = parseFloatFromInput($mileageInputDisplay.text());

		$mileageInputSlider.css('--min', min);
		$mileageInputSlider.css('--max', max);
		$mileageInputSlider.attr('value', val);

		$mileageInputSlider.trigger('change');
	}

	function setSmallInput($column, params) {
		const html = `
			<p class="inp inp--suffix item-label">
				<label for="${params.inputId}" id="${params.labelId}" class="inp__label">${params.labelText}</label>
				<span class="cng-calculator__inp-wrap">
					<input type="number"
						name="${params.inputId}"
						class="inp__text" id="${params.inputId}"
						role="spinbutton"
						aria-labelledby="${params.labelId}" 
						min="${params.min}" max="${params.max}" step="${params.step}"
						aria-valuemin="${params.min}" aria-valuemax="${params.max}"
						aria-valuenow="${params.value.toFixed(params.decimalPlaces)}"
						value="${params.value.toFixed(params.decimalPlaces)}"
						aria-valuetext="${params.value.toFixed(params.decimalPlaces)}&nbsp;${params.suffix}"
						data-suffix="${params.suffix}" data-decimal-places="${params.decimalPlaces}"
					/>
					<span class="inp__suffix">${params.suffix}</span>
				</span>
			</p>`;

		$column.html(html);
	}

	function setLargeInput($column, params) {
		const html = `
			<p class="inp__label" id="${params.labelId}">${params.labelText}</p>
			<div class="inp__text" id="${params.inputId}"
				aria-labelledby="${params.labelId}"
				tabindex="0" role="spinbutton"
				aria-valuemin="${params.min}"
				aria-valuemax="${params.max}"
				aria-valuenow="${params.value}"
				aria-valuetext="${params.value} ${params.suffix}"
				value="${params.value}"
				data-min="${params.min}" data-max="${params.max}" data-step="${params.step}"
				data-suffix="${params.suffix}" data-decimal-places="${params.decimalPlaces}">
				<span class="inp__display">${params.value.toFixed(params.decimalPlaces)}&nbsp;${params.suffix}</span>
				<span class="inp__arrows">
					<button class="arrow-up" aria-hidden="true" tabindex="-1">
						<span class="icon-svg icon-svg--chevron-small-up" aria-hidden="true">
							<svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink">
								<use xlink:href="/img/bg/icons-svg.svg#icon-chevron-small-up" width="100%" height="100%" focusable="false"></use>
							</svg>
						</span>
					</button>
					<button class="arrow-down" aria-hidden="true" tabindex="-1">
						<span class="icon-svg icon-svg--chevron-small-down" aria-hidden="true">
							<svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink">
								<use xlink:href="/img/bg/icons-svg.svg#icon-chevron-small-down" width="100%" height="100%" focusable="false"></use>
							</svg>
						</span>
					</button>
				</span>
			</div>`;

		$column.html(html);
	}

	function getWindowSize() {
		return MQ('lgUp') ? WindowSize.LARGE : WindowSize.SMALL;
	}

	///////////////////////////////////////////////////////
	/// INITIALIZATION
	///////////////////////////////////////////////////////

	$(window).trigger('resize');
	initSlider();
};
